const indexItems = [
  {
    title: '娱乐圈档案',
    desc: '明星动态、恋情曝光、合约纠纷一网打尽',
    count: '1,286篇',
    icon: 'ri-movie-2-line',
  },
  {
    title: '网红观察室',
    desc: '直播圈、短视频圈的翻车与崛起',
    count: '974篇',
    icon: 'ri-live-line',
  },
  {
    title: '互联网江湖',
    desc: '大厂内幕、创业故事、科技圈八卦',
    count: '832篇',
    icon: 'ri-global-line',
  },
  {
    title: '金融八卦',
    desc: '资本市场背后的隐秘交易与人物',
    count: '651篇',
    icon: 'ri-funds-line',
  },
  {
    title: '社会热点追踪',
    desc: '公共事件的多角度爆料与分析',
    count: '543篇',
    icon: 'ri-radar-line',
  },
  {
    title: '体育电竞圈',
    desc: '赛场内外的恩怨情仇与转会风云',
    count: '418篇',
    icon: 'ri-trophy-line',
  },
  {
    title: '海外吃瓜',
    desc: '国际娱乐圈与名流圈的最新动态',
    count: '327篇',
    icon: 'ri-earth-line',
  },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            爆料合集
          </h2>
          <span className="text-xs text-foreground-500 mt-1">7大主题索引</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`bg-background-100 hover:bg-background-200 rounded-xl p-5 transition-colors cursor-pointer group border border-background-200/50 ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-400 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-heading text-base font-bold text-foreground-200 group-hover:text-primary-400 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-600 flex-shrink-0 ml-2">{item.count}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}